<template>
    <div class="related-feed gcmcn-card">
        <feed-card
            class="dashboard-feed-card"
            :feed="source"
            :display-config-button="false"
            :universes="otherPropValue.universes"
            :events="otherPropValue.events"
            :configurations="otherPropValue.configurations"
            :defaultPreviewImageUrl="otherPropValue.defaultPreviewImageUrl"
            :unMutedFeedsUid="otherPropValue.unMutedFeedsUid"
            dashboardCard
        ></feed-card>
        <div class="see-more-link" @click="showFeed">
            <i class="el-icon-view"></i>
            <span>SEE MORE</span>
        </div>
    </div>
</template>

<script>
import moment from 'moment';
import { FeedCard } from 'gcmcn-common';
export default {

    components: {
        FeedCard,
    },



    props: {
        index: {
            type: Number,
            required: true,
        },
        source: {
            type: Object,
            default () {
                return {};
            }
        },
        otherPropValue: {
            type: Object,
        }
    },

    data: function(){
        return {
            checked: true,
        };
    },

    computed: {
    },
    methods: {
        showFeed (){
            this.$router.push({
                name: 'feeds',
                params: { feedUid: this.source.uid }
            });
        },
    },
};
</script>

<style lang="scss">
.related-feed {

    .edit-feed{
        display: flex;
        margin-left: auto;
        margin-bottom: 15px;
    }
    .broadcasting-text{
        font-size: 9px;
        color: #28E37C;
    }
    .data-title{
        font-size: 9px;
    }
    .data-value{
        font-size: 12px;
        font-weight: bold;
    }
    &.related-feed {
        margin-top: 10px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/page/Events/relatedFeed.vue